import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Rx";
import { Expenses } from "../../models/interfaces/expenses.model";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Member } from "../../models/interfaces/member.model";
import { ExpensesAddPage } from "../../pages/expenses/expenses_add";
import { ExpensesUpdatePage } from "../../pages/expenses/expenses_update";
import { HarelineAddPage } from "../../pages/hareline/hareline_add";
import { HarelineViewPage } from "../../pages/hareline/hareline_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-expenses",
  templateUrl: "expenses.html",
})

export class ExpensesPage {

  public static readonly EXPENSES_ADD_ACCESS = "addExpenses";
  public static readonly EXPENSES_UPD_ACCESS = "updateExpenses";
  public static readonly EXPENSES_DEL_ACCESS = "deleteExpenses";
  public static readonly HARELINE_ADD_ACCESS = "addHareline";
  private AddDefaults: boolean = false;
  private hl_id: number;
  private hl_datetime: string;
  private hl_runno: number;
  private avg_cost: number;
  private ttl: number = 0;
  private isfirstrun: boolean = true;
  private expenses$: any;
  private expenses: Expenses;
  private currentUser: Member;
  private hasAddHarelineAccess: boolean = false;
  private hasAddExpensesAccess: boolean = false;
  private hasUpdateExpensesAccess: boolean = false;
  private hasDeleteExpensesAccess: boolean = false;
  private styleName: string ="";

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController,
    private db: DbserviceProvider, public modalCtrl: ModalController,
  ) {
    this.styleName=this.configService.getConfig("STYLENAME");
    this.hl_id = this.navParams.get("hareline")[0].hl_id;
    this.hl_datetime = this.navParams.get("hareline")[0].hl_datetime;
    this.hl_runno = this.navParams.get("hareline")[0].hl_runno;
  }

  private ionViewWillEnter() {
    console.log("ExpensesPage ionViewWillEnter");
    if (this.authService.currentUser) {
      this.hasAddHarelineAccess = this.db.hasAccess(ExpensesPage.HARELINE_ADD_ACCESS);
      this.hasAddExpensesAccess = this.db.hasAccess(ExpensesPage.EXPENSES_ADD_ACCESS);
      this.hasUpdateExpensesAccess = this.db.hasAccess(ExpensesPage.EXPENSES_UPD_ACCESS);
      this.hasDeleteExpensesAccess = this.db.hasAccess(ExpensesPage.EXPENSES_DEL_ACCESS);
    }
    this.onInitPage();
  }

  private addDefaultLines(){
    console.log("ExpensesPage addDefaultLines");

    this.ttl = 0;
    this.db.dbCol({
      "action": "select", "mapObject": "expenses",
      "sqlExtended": " where se_class='Expenses' and hareline.hl_id = " + this.hl_id + " order by expenses.se_order",
    }).subscribe((x) => {
      this.expenses$ = x;
      if (x.length === 0 && this.isfirstrun) {
        this.isfirstrun = false;
        // add default lines
        // select default values
        this.db.dbCol({
          "action": "select", "mapObject": "settings",
          "sqlExtended": " where se_class='Expenses' and se_attribute1=1 order by se_order",
        }).subscribe((addlines) => {

          addlines.forEach((defline) => {
             this.ttl = this.ttl + +defline.se_key_value * +defline.se_attribute2;
            const formValues: any = {
              "ex_amount": +defline.se_key_value * +defline.se_attribute2,
              "ex_date": this.hl_datetime,
              "ex_qty": +defline.se_attribute2,
              "ex_rate": +defline.se_key_value,
              "ex_remark": "",
              "hl_id": this.hl_id,
              "se_id": defline.se_id,
              "se_name_description": defline.se_name_description,
              "se_order": +defline.se_order,
            };

            this.db.dbCol({ "action": "insert", "mapObject": "expenses", ...formValues })
              .subscribe((ret) => {
                this.db.dbCol({
                  "action": "select", "mapObject": "expenses",
                  "sqlExtended": " where se_class='Expenses' and hareline.hl_id = " + this.hl_id + " order by expenses.se_order",
                }).subscribe((newlines) => {
                  this.expenses$ = newlines;
                });
              });
          });
        });
      }
      this.isfirstrun = false;
      x.forEach((exp) => {
        this.ttl = this.ttl + +exp.ex_amount;
      });
    });
    this.AddDefaults = false;
  }

  private onInitPage() {
    console.log("ExpensesPage onInitPage");

    this.ttl = 0;
    this.db.dbCol({
      "action": "select", "mapObject": "vw_expenses",
      "sqlExtended": " where se_class='Expenses' and hl_id = " + this.hl_id + " order by ex_amount",
    }).subscribe((x) => {
      this.expenses$ = x;
      if (x.length === 0) {
        // show button to add defaults
        this.AddDefaults  = true;
      }
      else{
        // hide button to add defaults
        this.AddDefaults = false;
      }
      // this.isfirstrun = false;
      x.forEach((exp) => {
        this.ttl = this.ttl + +exp.ex_amount;
      });
    });

    this.db.dbCol({
      "action": "select", "mapObject": "vw_expenses_avg_365",
    }).subscribe((x) => {
      this.avg_cost = parseInt(x[0].avg);
    });

  }

  private addExpense() {
    console.log("ExpensesPage addExpenses");
    this.navCtrl.push(ExpensesAddPage, { "expenses": this.navParams.data.hareline });
  }

  private updateExpense(expense: any ) {
    console.log("ExpensesPage addExpenses");
    this.navCtrl.push(ExpensesUpdatePage, { "expenses": expense });
  }

  private deleteExpenses(expense: any) {
    console.log("ExpensesPage deleteHareline");
    this.showConfirm("Expenses", "Do you want to delete this Expenseline?", expense);
  }

  private showConfirm(title: string, message: string, expense: any) {
    console.log("ExpensesPage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "DELETE FROM expenses WHERE expenses.ex_id=" + expense.ex_id,
            })
              .subscribe((ret) => {
                this.onInitPage();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {
          },
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }

  private ngOnDestroy() {
    console.log("ExpensesPage ngOnDestroy");
    // this.hareline$ = null;
  }

}



// WEBPACK FOOTER //
// ./src/pages/expenses/expenses.ts